import axios from "axios";

export default function getDashboardTodo(type, user, dayOffset) {
    return axios.get("/dashboard/getDashboardTodo/" + type + "/" + user + "/" + dayOffset);
}